import { Button, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';

import './OtherOperatorModal.scss';

interface Props {
    id?: string;
    rtl?: boolean;
    data: any;
    modalFirstButtonClick?: () => void;
    handleHeaderCancel?: () => void;
}

function OtherOperatorModal({ rtl, id, data, modalFirstButtonClick }: Props) {
    const { t } = useTranslation();

    return (
        <Modal className={'OtherOperator__Modal'} handleHeaderCancel={modalFirstButtonClick} id={id} rtl={rtl}>
            <Typography rtl={rtl} className='CC__MST mb-0 lh-sm' fontFamily='ScandiaWeb-Medium'>{t('Unfortunately_area_not_covered_mobily')} </Typography>
            <Typography rtl={rtl} className='CC__MST mb-1 lh-sm' fontFamily='ScandiaWeb-Medium'>{t('You_can_try_assigned_provider')} </Typography>
            <div>
                <Typography rtl={rtl} className='CC__MST mt-4 mb-1' fontSize='18px'>{t('Assigned_provider')}</Typography>
                <Typography rtl={rtl} className='CC__MST'>
                    <a className='OtherOperator__Link' href={data?.operatorUrl}>{rtl ? data?.operatorAr : data?.operatorEn}</a>
                </Typography>
            </div>
            <Button rtl={rtl} className='CC__MButton mb-4' onClick={modalFirstButtonClick}>{t('Got_it')}</Button>
        </Modal>
    )
}

export default OtherOperatorModal